/** 连续两帧后再执行，让浏览器先完成首屏布局与绘制 */
export function afterNextPaint(fn: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(fn);
  });
}

/** 在浏览器空闲时执行，避免与首帧抢主线程；`timeout` 保证久不空闲时仍会执行 */
export function runWhenIdle(fn: () => void, timeoutMs = 2000): void {
  const w = globalThis as typeof globalThis & {
    requestIdleCallback?: (cb: IdleRequestCallback, opts?: IdleRequestOptions) => number;
  };
  if (typeof w.requestIdleCallback === "function") {
    w.requestIdleCallback(() => fn(), { timeout: timeoutMs });
  } else {
    setTimeout(fn, 0);
  }
}

/** 先绘制再择机拉数据：用于非首屏路由的 JSON 等 */
export function deferForFastPaint(fn: () => void, idleTimeoutMs = 2200): void {
  afterNextPaint(() => runWhenIdle(fn, idleTimeoutMs));
}
